/**
 * 코스 상품 "이용 중" 조회 대상 여부 관련 유틸
 *
 * - 조회 대상이면 /v1/product/course/usage 결과로 이용 중일 때 구매 버튼을 비활성화한다.
 * - 아래 목록의 상품은 조회를 생략해 이용 중이어도 항상 구매 가능하다.
 */

/** 이용 중 조회를 생략하는 상품 ID 목록 */
const USAGE_CHECK_EXCLUDED_PRODUCT_IDS = new Set([
  'P9hcqg1j_bJDTtVA',
  'r7rC4K6hoPycJ0Gz',
  'qVNHW5pY8HZjbHKM',
  'Tvj1HF6vcvSgXPo-',
  '7g6LZsi0qBwLP5K1',
  'VVpX9YkX7hcxsMdE',
  'nO8efugcVGoFZWQb',
  'i3OS02dLW4eb_jj1',
  'x7X38suGrP9dcQiU',
  'DR4RZkbr_ZNsoltq',
  'lQP6eIqBBbi6G_1Q',
  'Nh8o32qxIXXqXR_O',
  'wprZm-glvDkO8enM',
  'iB9i8IjMv519AEb3',
  '18Mm87u5V0hU6B57',
  'WvA7mOd2zVCpgjSC',
  'o11lpOrtYZvft2kS',
  'YCs71D_HpHuzaIn-',
  'vKPAt48Z82J--OQW',
  'yn77N1jwEoadGi9k',
  'dyU762lu6RonOLhT',
  'Cb1rlUxvKLutuFyT',
  'C1GN6X0nwhF9y4m-',
  'rH76pcPI7w89wgFB',
  '9x2g5R-9DMQMAHSX',
]);

/**
 * 코스 상품 이용 중 조회 대상 여부
 * @param id 상품 ID (homeschoolId)
 * @returns 제외 목록에 있으면 false, 그 외는 true
 */
export const shouldCheckCourseUsage = (id: string): boolean =>
  !USAGE_CHECK_EXCLUDED_PRODUCT_IDS.has(id);
